import { myAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService.connected';
import { mySystemSettingsService } from './SystemSettingsService.connected';

export function useBrowsingRoleMissingDays() {
  return mySystemSettingsService.useSetting(
    myAppScopeService.useResolvedScopeIdentity(),
    'role_missing_days'
  );
}
